import React from 'react';

const MagnifyingGlass = () => (
  <svg
    width='100px'
    height='100px'
    viewBox='0 0 100 100'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <g
      id='Page-Not-Found-/-Modal'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g
        id='Page-Not-Found'
        transform='translate(-670.000000, -216.000000)'
        fill='#00604B'
        fillRule='nonzero'
      >
        <g transform='translate(0.000000, 104.000000)'>
          <g transform='translate(670.000000, 112.000000)'>
            <path
              d='M39.178,50.556 C38.8606667,48.3346667 38.9966667,46.3626667 39.586,44.64 C40.1753333,42.9173333 40.9686667,41.342 41.966,39.914 C42.9633333,38.486 43.9833333,37.1146667 45.026,35.8 C46.0686667,34.4853333 46.9753333,33.148 47.746,31.788 C48.5166667,30.428 48.902,28.932 48.902,27.3 C48.902,25.9853333 48.63,24.7386667 48.086,23.56 C47.542,22.3813333 46.7146667,21.4406667 45.604,20.738 C44.4933333,20.0353333 43.0766667,19.684 41.354,19.684 C39.7673333,19.684 38.226,20.0466667 36.73,20.772 C35.234,21.4973333 33.9193333,22.54 32.786,23.9 L30.678,21.996 C32.038,20.4546667 33.6246667,19.174 35.438,18.154 C37.2513333,17.134 39.3366667,16.624 41.694,16.624 C43.9153333,16.624 45.8306667,17.0773333 47.44,17.984 C49.0493333,18.8906667 50.2733333,20.1373333 51.112,21.724 C51.9506667,23.3106667 52.37,25.1013333 52.37,27.096 C52.37,28.9093333 51.996,30.5753333 51.248,32.094 C50.5,33.6126667 49.582,35.052 48.494,36.412 C47.406,37.772 46.352,39.1546667 45.332,40.56 C44.312,41.9653333 43.496,43.4726667 42.884,45.082 C42.272,46.6913333 42.102,48.516 42.374,50.556 L39.178,50.556 Z M41.014,63.816 C40.198,63.816 39.4726667,63.5213333 38.838,62.932 C38.2033333,62.3426667 37.886,61.5493333 37.886,60.552 C37.886,59.464 38.2033333,58.6253333 38.838,58.036 C39.4726667,57.4466667 40.198,57.152 41.014,57.152 C41.83,57.152 42.544,57.4466667 43.156,58.036 C43.768,58.6253333 44.074,59.464 44.074,60.552 C44.074,61.5493333 43.768,62.3426667 43.156,62.932 C42.544,63.5213333 41.83,63.816 41.014,63.816 Z'
            />
            <g id=''>
              <path
                d='M99.546985,97.3242164 L70.4074696,68.183589 C77.1064303,60.9570324 81.2468997,51.2890637 81.2468997,40.625 C81.2468997,18.1894541 63.0639986,0 40.6234498,0 C18.1829011,0 0,18.1894541 0,40.625 C0,63.0605459 18.18876,81.25 40.6234528,81.25 C51.2773408,81.25 60.9547094,77.1152318 68.2005279,70.4023421 L97.3400433,99.5429635 C97.632995,99.8437524 98.023605,100 98.4337468,100 C98.8438886,100 99.2333246,99.8474002 99.5383933,99.5421886 C100.152429,98.9257812 100.152429,97.9492188 99.546988,97.3242164 L99.546985,97.3242164 Z M40.6234528,78.125 C19.9406465,78.125 3.12488076,61.3027334 3.12488076,40.625 C3.12488076,19.9472666 19.9465054,3.125 40.6234528,3.125 C61.3003972,3.125 78.1220219,19.9472666 78.1220219,40.625 C78.1220219,61.3027334 61.3062561,78.125 40.6234528,78.125 Z'
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default MagnifyingGlass;
